import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=fcbcefe2"
import script from "../../controllers/student/student-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/student/student-edit.js?vue&type=script&lang=js&external"
import style0 from "./StudentEdit.vue?vue&type=style&index=0&id=fcbcefe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports